import * as React from "react";
import {cx}       from "emotion";

import {cs}                             from "@Common/react/chain-services";
import {Responsive}                     from "@Common/ui-components/responsive";
import {
    faAddressCard,
    faBuilding,
    faExternalLinkAlt,
    faTruck,
    faShieldHalved,
    faUsers,
}                                       from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}                from "@fortawesome/react-fontawesome";

import {createIdFromOfficeName}         from './office-filter-bar';

import './office-management-card.scss';
import { buildUrlQuery } from "@Common/utils/build-url-query";

export const OfficeCard = ({office, query, routerHistory}) => cs(
    // @ts-ignore
    ["responsive", ({}, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ({responsive}) => (
        <div className={cx("card-office-CuSO4", office.branchName)}
            id={createIdFromOfficeName(office.branchName)}>
            <article  xd-qa-type="card" xd-qa-name={office.idBranch} className={`item item-office`}>
                <div className="info-office">
                    <div className="office-title">
                        <h4 title={office.branchName} className={office.branchActive ? "name-office" : "name-office-inactive"}
                            xd-qa-type="label"
                            xd-qa-name="Branch Name"
                        >
                            {office.branchName}
                        </h4>
                        {
                            !office.branchActive &&
                            <span className="office-inactive" xd-qa-type="label" xd-qa-name="Inactive">Inactive</span>
                        }
                    </div>
                    {
                        responsive.ge("md") &&
                        <div title={office.branchLinkId} className="office-link-id">
                            {
                                office.branchLinkId &&
                                <>
                                    <span className="link-id-title" xd-qa-type="label" xd-qa-name="Office Link ID">Office Link ID</span>
                                    <span xd-qa-type="text" xd-qa-name="Link Id" className="link-id-text">
                                        {office.branchLinkId}
                                    </span>
                                </>
                            }
                        </div>
                    }
                    {

                        <div className="address-office" title={ addressHoveredText(office) } >
                            {
                                (office.branchAddress1 || office.branchCity || office.branchState) && responsive.ge("md") &&
                                <span className="address-title" xd-qa-type="label" xd-qa-name="Address">Address</span>
                            }
                            {
                                office.branchAddress1 &&
                                <span xd-qa-type="text" xd-qa-name="Address 1" className="address-text">
                                    {office.branchAddress1}
                                </span>
                            }
                            {
                                office.branchAddress2 &&
                                <span xd-qa-type="text" xd-qa-name="Address 2" className="address-text one-line">
                                    {office.branchAddress2}
                                </span>
                            }
                            {
                                (office.branchCity || office.branchState || office.branchZip) &&
                                <span xd-qa-type="text" xd-qa-name="City State Zip" className="address-text">
                                    {office.branchCity}, {office.branchState} {office.branchZip}
                                </span>
                            }
                        </div>
                    }
                </div>
                <div className="ui">
                    <button aria-label="General Info" xd-qa-type="button" xd-qa-name="General Info" onClick={() => (
                        routerHistory.replace(`/account/admin/office${buildUrlQuery({search: query?.search, modal: "manage", office: office.idBranch, menu: "general"})}`)
                    )}><FontAwesomeIcon icon={faBuilding}/></button>
                    <button aria-label="Contact Info" xd-qa-type="button" xd-qa-name="Contact Info" onClick={() => (
                        routerHistory.replace(`/account/admin/office${buildUrlQuery({search: query?.search, modal: "manage", office: office.idBranch, menu: "contact"})}`)
                    )}><FontAwesomeIcon icon={faAddressCard}/></button>
                    <button aria-label="Shipping Info" xd-qa-type="button" xd-qa-name="Shipping Info" onClick={() => (
                        routerHistory.replace(`/account/admin/office${buildUrlQuery({search: query?.search, modal: "manage", office: office.idBranch, menu: "shipping"})}`)
                    )}><FontAwesomeIcon icon={faTruck}/></button>
                    <button aria-label="Security" xd-qa-type="button" xd-qa-name="Security" onClick={() => (
                        routerHistory.replace(`/account/admin/office${buildUrlQuery({search: query?.search, modal: "manage", office: office.idBranch, menu: "security"})}`)
                    )}><FontAwesomeIcon icon={faShieldHalved}/></button>
                    <button aria-label="View Users" xd-qa-type="button" xd-qa-name="View Users" onClick={() => {
                        routerHistory.replace(`/account/admin/user?office=${office.idBranch}`)
                        window.scrollTo(0, 0)
                    }}><FontAwesomeIcon icon={faUsers}/></button>
                    <button aria-label="Office Assets" xd-qa-type="button" xd-qa-name="Office Assets" onClick={() => {
                        routerHistory.push(`/account/admin/office/address-lists?office=${office.idBranch}`)
                        window.scrollTo(0, 0)
                    }}><FontAwesomeIcon icon={faExternalLinkAlt}/></button>
                </div>
            </article>
        </div>
    )
);

const addressHoveredText = (office) => {
    let hoveredText = `${office.branchAddress1}\n`

    if(office.branchAddress2) {
        hoveredText+= `${office.branchAddress2}\n`
    }

    hoveredText+= `${office.branchCity}, ${office.branchState} ${office.branchZip}`

    return hoveredText
}